import React from "react";
import { Content } from "../components/content";
import { H1, Text } from "../components/text";
import { Hero } from "../components/hero";
import { Layout } from "../components/layout";
import { Seo } from "../components/seo";
import HeroImage from "../images/pages/courses/hero.jpg";
import { Grid } from "../components/grid";
import { TripCard } from "../components/trip-card";
import { Loading } from "../components/loading";
import { Spacer } from "../components/spacer";

export const Courses = ({ courses, isLoading }) => {
  return (
    <Layout>
      <Seo lang='en' title='Train with us // ITC Courses' image={HeroImage} />
      <Hero image={HeroImage}>
        <H1>WVS India</H1>
      </Hero>
      <Content>
        <Text>
          WVS India was established in 2010 and has operated a charity
          veterinary hospital in the Nilgiris since then. The objective of WVS
          India is to provide veterinary skills development, inspiration and
          advice for veterinarians and veterinary assistants, especially in the
          field of humane dog population control and rabies control.
        </Text>
        <Text>
          WVS India programmes and experiences provide participating
          veterinarians with skills and confidence in good quality surgery and
          related clinical skills. They also increase understanding in a
          veterinarian's role in public health matters like rabies control and
          responsible use of antibiotics. It challenges veterinarians to think
          how they can be actively promoting animal welfare in their daily work.
        </Text>
        <Text>
          WVS India welcomes veterinarians who are actively working in the
          clinical field and who are likely to be able to continue to spay and
          neuter dogs.
        </Text>
        <Text>
          We also welcome ABC project managers to visit our activities to learn
          and see in practice the important elements of good ABC-surgery
          project.
        </Text>
        <Spacer height={[3]} />
        {isLoading ? (
          <Loading />
        ) : (
          <Grid centreItems columns={3} withBottomMargin>
            {courses.map((project) => (
              <TripCard
                key={project.id}
                location={project.country}
                imageSource={
                  project.images &&
                  project.images.length &&
                  project.images.find((image) => image.isFeaturedImage).url
                }
                title={project.name}
                to={project.path}
              />
            ))}
          </Grid>
        )}
      </Content>
    </Layout>
  );
};
